export default __webpack_public_path__ + "static/media/Hauberk of the Farseeker.a41402fc.jpg";